import { Component, Input, OnInit } from '@angular/core';
import {TimelineHelper } from '../../../../_helpers/learning-plan-helper/timeline.helper';
import { TimelineSection } from '../../../../_models/timeline-models/section-listing.model';

@Component({
    selector: 'award-section',
    templateUrl: './award-section.component.html',
    styleUrls: ['./award-section.component.css'],
    standalone: false
})
export class AwardSectionComponent implements OnInit {
  @Input("timelineSection") timelineSection: TimelineSection;

  constructor(
  ) { }

  ngOnInit() {
    
  }

}
